import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface FilterChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Selected state (rendered as aria-pressed). */
  active?: boolean;
  /** Optional count bubble after the label. */
  count?: ReactNode;
}

/** Pill-shaped toggle used for status/category filters above lists. */
export const FilterChip = forwardRef<HTMLButtonElement, FilterChipProps>(function FilterChip(
  { active = false, count, className, children, type = 'button', ...rest },
  ref,
) {
  return (
    <button ref={ref} type={type} aria-pressed={active} className={cn('adm-filter-chip', className)} {...rest}>
      {children}
      {count !== undefined && count !== null && <span className="adm-filter-count">{count}</span>}
    </button>
  );
});
